import { FC, ReactNode } from "react";
import VariantItem from "~/components/Items/VariantItem";
import styles from "./ColorSelect.module.scss";
import classNames from "classnames";
import { getHexCodeColor } from "~/utils/converters";
import Icon from "~/components/Icon";
import Tick from "~/svgs/tick.svg";

interface ColorSelectProps {
  title?: string;
  options?: { label: string; value_index: number; disabled?: boolean }[];
  value?: number | string;
  onChange?: (value: {
    label: string;
    value_index: number;
    disabled?: boolean;
  }) => void;
  extra?: ReactNode;
}

const ColorSelect: FC<ColorSelectProps> = ({
  title,
  options,
  value,
  onChange,
  extra,
}) => {
  const optionsSelected = options?.find((op) => op.value_index ? op.value_index === value : getHexCodeColor(op.label) === value);
  return (
    <VariantItem title={title} extra={extra} value={optionsSelected?.label}>
      <div className={classNames("flex gap-3 flex-wrap", styles.single_select)}>
        {options?.map((op) => (
          <div
            key={op.value_index}
            className={classNames(styles.select_item, {
              [styles.selected]: op.value_index ? op.value_index === value : getHexCodeColor(op.label) === value,
              [styles.disabled]: op.disabled,
            })}
            onClick={op.disabled ? undefined : () => onChange?.(op)}
          >
            <div className={styles.color} style={{ background: getHexCodeColor(op.label) }} >
              <Icon name="tick" className={styles.icon} />
            </div>
          </div>
        ))}
      </div>
    </VariantItem>
  );
};

export default ColorSelect;
